export function logBuildInfo(): void {
    const build = __LIGHTHOUSE_BUILD__
    const shortSha = build.sha === 'local' ? build.sha : build.sha.slice(0, 7)

    console.info(
        `%c Lighthouse %c ${build.env} @ ${shortSha} `,
        'background:#111;color:#fff;padding:2px 6px;border-radius:3px;font-weight:600',
        'color:#666;font-weight:normal',
        build,
    )

    if (typeof window !== 'undefined') {
        ;(window as Window & { __LIGHTHOUSE_BUILD__?: LighthouseBuildInfo }).__LIGHTHOUSE_BUILD__ = build
    }
}
